/** @module Auth0PreLoginHandlerHelper */
/* eslint-disable import/extensions */
import Auth0HandlerRegistry from './auth0-pre-login-handler-config.mjs';

class Auth0PreLoginHandlerHelper {
  constructor(options) {
    console.log(`Auth0PreLoginHandlerHelper initialize using ${JSON.stringify(options)}`);
    this._handlerRegistry = Auth0HandlerRegistry.registeredHandlers.map((h) => {
      return new h.HandlerClass({
        name: h.handlerName, description: h.handlerDescription, isDefault: h.isDefault, ...options,
      });
    });

    console.log(`Auth0PreLoginHandlerHelper initialized with ${this._handlerRegistry.length} handlers...`);
  }

  get handlers() {
    return this._handlerRegistry;
  }

  /**
   * @function
   * @description This function determines, based on app state whether or not this handler is to be chosen as the pre-login handler. Only zero or one will be chosen (first one to return true here)
   * @returns {Auth0PreLoginHandlerBase} The Auth0PostLoginHandlerBase object that should handle the post-login actions
   */
  selectHandler = async () => {
    const found = await Promise.all(this.handlers.map(async (h) => {
      const shouldRun = await h.shouldHandle();
      return { handler: h, shouldRun };
    }));

    const filteredHandlers = found
      .filter(result => result.shouldRun)
      .map(result => result.handler);

    if (!filteredHandlers || !filteredHandlers.length) {
      return this.defaultHandler;
    }
    if (filteredHandlers.length > 1) {
      throw new Error(`Pre login handler has detected more than one handler that is attempting to handle pre login actions. Check shouldRun() for "${found.map(f => f.name).join(', ')}"`);
    }
    return filteredHandlers.pop();
  };

  /**
   * @function
   * @description This function determines, based on  app state whether or not this handler is to be chosen as the pre login handler. Only zero or one will be chose (first one to return true here) and then runs its actions.
   * @returns {bool} Indicating whether or not the login request has been handled or should continue
   */
  selectAndRunPostLoginActions = async (viewOptions = {}) => {
    const theHandler = await this.selectHandler();

    if (!theHandler) {
      console.log('Auth0PreLoginHandlerHelper found no handlers, proceed with login request...');
      return false;
    }
    console.log(`Auth0PreLoginHandlerHelper selected the "${theHandler.name}" handler...`);
    const handled = await theHandler.run(viewOptions);
    console.log(`Auth0PreLoginHandlerHelper "${theHandler.name}" has handled the request => ${handled}`);
    return handled;
  };
}

export default Auth0PreLoginHandlerHelper;
